import { render, staticRenderFns } from "./FieldSettingSize.vue?vue&type=template&id=5aa17c9f&scoped=true&"
import script from "./FieldSettingSize.vue?vue&type=script&lang=js&"
export * from "./FieldSettingSize.vue?vue&type=script&lang=js&"
import style0 from "./FieldSettingSize.vue?vue&type=style&index=0&id=5aa17c9f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa17c9f",
  null
  
)

export default component.exports